<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { addPV, addUV } from '@/api/index';
import Cookies from 'js-cookie';
import {
  getPartner,
  getBanner,
  getVideo,
  getDetail,
  getDocumentation,
  getInfoDetail,
  getCompany,
  getCases,
  getProduct,
  getBusiness
} from '@/api/index';
import { URLS } from '@/config/domains';
export default {
  name: 'App',
  data() {
    return {
      screenWidth: 0 // 屏幕宽度
    };
  },
  mounted() {
    this.trackUniqueVisitor();
    this.screenWidth = this.getScreenWidth(); // 获取当前屏幕宽度
    this.$store.commit('setScreenWidth', this.screenWidth); // 设置是否是移动端
    this.onResize((width) => {
      // 监听屏幕变化
      console.log('屏幕宽度发生变化：', width);
      this.screenWidth = width; // 更新屏幕宽度
      this.$store.commit('setScreenWidth', this.screenWidth); // 设置是否是移动端
    });
    this.init();
  },
  methods: {
    init() {
      getBanner().then((res) => {
        if (res.code === 200) {
          this.$store.commit('setBanner', res.result);
        }
      });
    },
    // 全局跳转方法 - 打开新标签页
    openNewTab(urlKey) {
      const url = URLS[urlKey];
      if (url) {
        window.open(url, '_blank');
      } else {
        console.warn(`URL key "${urlKey}" not found in URLS configuration`);
      }
    },
    // 全局跳转方法 - 当前标签页跳转
    navigateTo(urlKey) {
      const url = URLS[urlKey];
      if (url) {
        window.location.href = url;
      } else {
        console.warn(`URL key "${urlKey}" not found in URLS configuration`);
      }
    },
    // 获取当前屏幕宽度
    getScreenWidth() {
      return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    },

    // 判断是否是移动端
    isMobile() {
      return this.getScreenWidth() <= 768;
    },

    // 监听屏幕变化
    onResize(callback) {
      window.addEventListener('resize', () => {
        callback(this.getScreenWidth());
      });
    },
    trackPageView() {
      // 记录PV
      addPV().then((res) => {
        console.log('PV recorded:', res);
      });
    },
    trackUniqueVisitor() {
      // 检查cookie判断是否新访客
      const visitorId = Cookies.get('visitor_id');
      if (!visitorId) {
        // 生成唯一ID并设置cookie（有效期30天）
        const newVisitorId = this.generateVisitorId();
        Cookies.set('visitor_id', newVisitorId, { expires: 30 });
        // this.trackPageView();
        // 记录UV
        addUV().then((res) => {
          console.log('UV recorded:', res);
        });
      } else {
        this.trackPageView();
      }
    },
    generateVisitorId() {
      // 生成随机访客ID
      return 'visitor_' + Math.random().toString(36).substr(2, 9);
    }
  }
};
</script>

<style lang="less">
html {
  min-width: 1440px;
  overflow-x: auto;
  overflow-y: auto;
  &::-webkit-scrollbar {
    &:vertical {
      width: 0;
    }
    &:horizontal {
      // Keep horizontal scrollbar visible
      height: 30px;
    }
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: hidden;
}

* {
  padding: 0;
  margin: 0;
}
.van-sticky--fixed {
  z-index: 1001 !important;
}
.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.flex {
  display: flex;
  align-items: center;

  .flex-col {
    flex: 1;
  }
}

.img_cover {
  width: 100%;
  height: 100%;
}

.main-banner {
  display: flex;

  img {
    width: 100%;
    // height: 600px;
  }
}

.van-popover {
  .van-popover__arrow {
    display: none !important;
  }

  .van-popover__content {
    background-color: rgba(0, 0, 0, 0.5) !important;
    border-radius: 0 !important;
    padding: 10px 0;
    box-sizing: border-box;
  }

  .van-hairline--bottom::after {
    display: none !important;
  }

  .van-popover__action-text {
    color: rgba(255, 255, 255, 0.75) !important;
    line-height: 14px !important;
    font-weight: 400;
  }

  .van-popover__action {
    width: 190px !important;

    &:hover .van-popover__action-text {
      color: #fff !important;
      font-weight: 700;
    }
  }
}

.main-title .subtitle {
  font-family: SourceHanSansCN-Light;
  text-transform: uppercase;
  position: absolute;
  font-size: 32px;
  color: rgba(0, 0, 0, 0.1);
  text-align: center;
  font-weight: 200;
  top: 3px;
  left: 50%;
  transform: translate(-50%, 30px);
}

.case-list {
  display: flex;
  margin-top: 30px;
  width: 1480px;
  flex-wrap: wrap;
  justify-content: space-between;

  .item {
    position: relative;
    width: 467px;
    height: 300px;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 40px;
    background-color: #eee;
    border-radius: 8px;

    .item-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
    }

    .item-mask {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 127px;
      z-index: 2;
      background: rgba(76, 123, 203, 0.6);
      border-radius: 8px 8px 0 0;
      transform: translate(0, 68px);
      padding-left: 24px;
      padding-right: 24px;
      box-sizing: border-box;

      .item-mask-title {
        font-size: 20px;
        color: #ffffff;
        font-weight: 500;
        line-height: 60px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        max-height: 80px;
        overflow: hidden;
      }

      .item-mask-desc {
        padding-top: 5px;
        font-size: 14px;
        color: #ffffff;
        font-weight: 400;
        overflow: hidden;
        max-height: 48px;
        line-height: 20px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 5px;
      }

      .item-mask-icon {
        img {
          width: 30px;
          height: 6px;
        }
      }
    }

    &:hover {
      .item-mask {
        animation: updown 0.3s linear forwards;
        height: 96px;
      }

      .item-mask-title {
        line-height: 28px;
        margin-top: 14px;
      }

      @keyframes updown {
        from {
          transform: translate(0, 45px);
        }

        to {
          transform: translate(0, 0);
        }
      }
    }
  }
}

.tab-card {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;

  .card-content {
    flex: 0 0 75px;
    height: 100%;
    border-bottom: 4px solid transparent;
    box-sizing: border-box;
    transition: all 0.3s;

    .item-icon {
      width: 100%;
      height: 75px;
      text-align: center;
      background-position: center 0;
      background-repeat: no-repeat;
      background-size: 75px auto;
    }

    .item-text {
      display: flex;
      height: calc(100% - 115px);
      align-items: center;
      justify-content: center;
      font-size: 28px;
      font-weight: 400;
      color: #000;
    }

    &:hover {
      border-bottom: 4px solid #3770ff;
      color: transparent;
      background-image: linear-gradient(to bottom, transparent 50%, rgba(24, 164, 255, 0.1), rgba(33, 229, 255, 0.1));

      .item-text {
        color: #3770ff;
      }
    }

    &.enter {
      .item-icon {
        animation: enter 0.2s steps(16) forwards;
      }
    }

    &.leave {
      .item-icon {
        animation: leave 0.2s steps(16) forwards;
      }
    }

    @keyframes enter {
      from {
        background-position: center 0;
      }

      to {
        background-position: center -1195px;
      }
    }

    @keyframes leave {
      from {
        background-position: center -1195px;
      }

      to {
        background-position: center 0;
      }
    }
  }
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

  &.two {
    -webkit-line-clamp: 2;
  }
}
.ant-pagination {
  line-height: 30px !important;
  li {
    height: 30px !important;
    font-size: 18px !important;
  }
  .anticon {
    font-size: 18px !important;
    line-height: 30px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
}
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  height: 30px !important;
}
</style>
